import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-6 mt-12">
      <div className="container mx-auto text-center">
        <p>
          &copy; {new Date().getFullYear()} <a href="https://aigenr.cc" className="text-blue-400 hover:underline">aigenr.cc</a> &mdash; All rights reserved.
        </p>
        <p className="mt-2 text-sm">
          Powered by AI Image Generator | <a href="/about" className="hover:underline">About</a> | <a href="/help" className="hover:underline">Help</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;